import { action, observable } from 'mobx';

import { PersonLicenseViewModel } from '@app/Models';
import ApiService from '@app/Services/ApiService';
import { ApiUrls } from '@app/AppConstants';
import { PromiseCompletion } from '@app/Classes/PromiseCompletion';

export default class LicenseBlockStore {
    @observable personLicense: PersonLicenseViewModel[];
    @observable showAllLicenses: boolean = false;
    private personId: string;
    public loader: PromiseCompletion = new PromiseCompletion();

    constructor(personId: string) {
        this.personId = personId;
        this.loadPersonLicense(personId);
    }

    @action.bound
    async loadPersonLicense(selectedPersonId: string) {
        const params = { personId: selectedPersonId, showAll: this.showAllLicenses };
        const { data: licenses } = await ApiService.getTypedData<PersonLicenseViewModel[]>(ApiUrls.PersonLicenseUrl, params, {completion: this.loader});
        this.personLicense = licenses;
    }

    @action.bound
    switchLicenses() {
        this.showAllLicenses = !this.showAllLicenses;
        this.personId && this.loadPersonLicense(this.personId);
    }

    get idPerson() {
        return this.personId;
    }

    setPersonId(personId: string) {
        this.personId = personId;
    }
    
}